import React from 'react';

export const Loading = () => {
  return <>Loading...</>;
};
